// Static profile content for the portfolio.
// Edit this file to update the hero, about, experience, and footer.

export const profile = {
  name: 'Shaik Hatim',
  role: 'Builder · Data Engineer @ Optum',
  tagline: 'I build things that ship.',
  avatar: '/profile.jpg',
  location: 'San Francisco Bay Area',
  email: 'shaik@getrerun.app',
  website: 'https://shaikhatim.com',

  // Current focus — shown as callout pills in the hero. Both apps are live;
  // `highlight` marks the one getting most of the attention right now.
  currents: [
    {
      name: 'Rerun',
      url: 'https://getrerun.app',
      label: 'Building',
      live: true,
    },
    {
      name: 'Sorevo',
      url: 'https://sorevo.app',
      label: 'Up next',
      live: true,
      highlight: true,
    },
  ],

  // Short hero blurb
  intro:
    'Computer Engineering grad from UT Dallas, now turning data into decisions as a Data Engineer at Optum. I\'ve built and launched two apps, Rerun and Sorevo, and I still live for hackathons: radar, AI, robotics, and web development.',

  // Longer about section. Each string is a paragraph.
  about: [
    'system.out.println("Hello World"); I live for hackathons, late-night coding binges, and building cool stuff just because it\'s fun. Powered by caffeine, I\'m always pumped to dive into a tech challenge and mess around with fresh ideas.',
    "By day I'm a Data Engineer at Optum, building scalable Power BI dashboards on Azure SQL and Databricks to make sense of revenue-cycle data. Before that I interned as an analyst at UnitedHealth Group and led AI/ML mentorship and industry partnerships across UT Dallas tech orgs.",
    'But hackathons are my thing. I build hardware and software prototypes just to see if I can: radar-based sensing, assistive robotics, computer vision, edge AI. If it can come together in a weekend, I have probably tried it, and a good few have won.',
    'Right now, I\'m building and shipping two apps: Rerun (getrerun.app) and Sorevo (sorevo.app), my AI travel planner and the big thing I\'m going all-in on next. Sorevo turns a plain-language trip description into a living, shareable trip page, with one link that works on the web and opens the iOS app through universal links.',
  ],

  // Skills / focus areas.
  skills: [
    'Python',
    'SQL',
    'Java',
    'C++',
    'React',
    'Machine Learning / AI',
    'Computer Vision',
    'Power BI',
    'Databricks',
    'Azure SQL',
    'Azure Pipelines',
    'Embedded / IoT',
    'Raspberry Pi',
    'Arduino / ESP32',
    'Flask',
    'CCNA / Networking',
  ],

  // Professional + leadership experience (most recent first).
  experience: [
    {
      company: 'Optum',
      role: 'Data Engineering Associate',
      period: 'Jul 2026 - Present',
      description:
        'Engineering the data pipelines behind revenue-cycle (RCM) analytics: building and maintaining scalable ETL with Azure Pipelines, Databricks, and Azure SQL, and productionizing clean, reliable datasets that power reporting and BI across the organization.',
      stack: ['Azure Pipelines', 'Databricks', 'Azure SQL', 'Python', 'SQL'],
    },
    {
      company: 'Optum',
      role: 'Product & Business Development Associate',
      period: 'Jul 2025 - Jul 2026',
      description:
        'End-to-end revenue-cycle (RCM) analytics covering data engineering, deep exploratory analysis, and visualization. Built scalable Power BI dashboards and BI solutions on Azure SQL and Databricks to uncover trends and optimize revenue operations through data-driven decisions.',
      stack: ['Power BI', 'Azure SQL', 'Databricks', 'SQL'],
    },
    {
      company: 'UnitedHealth Group',
      role: 'Analyst Intern',
      period: 'Jun 2024 - Aug 2024',
      description:
        'Built production reports that turned complex data into clear marketing insights, and explored predictive analytics with logistic-regression propensity models to forecast customer engagement. Managed and analyzed large datasets in Databricks, SQL, and Python with the E&I Marketing team.',
      stack: ['Databricks', 'SQL', 'Python', 'Logistic Regression'],
    },
    {
      company: 'AIS UTD (Artificial Intelligence Society)',
      role: 'Industry Coordinator & AIM Mentor',
      period: 'Sep 2023 - Apr 2024',
      description:
        'Secured AI and Data Science company partnerships for events and workshops, and mentored a team of mentees through a 10-week machine-learning project, bridging theory with hands-on Python and best practices.',
      stack: ['Machine Learning', 'Python', 'Mentorship'],
    },
    {
      company: 'IEEE UTD',
      role: 'Forge Member',
      period: 'Feb 2023 - May 2023',
      description:
        'Built a voice-controlled car with a 5-person team over a 10-week project, combining ML algorithms with microcontroller programming.',
      stack: ['Machine Learning', 'Microcontrollers', 'Embedded'],
    },
    {
      company: 'ACM UTD',
      role: 'Outreach Member',
      period: 'Aug 2022 - May 2023',
      description:
        'Ran interactive sessions introducing high-school students to STEM opportunities and college pathways, collaborating with companies and professionals across the field.',
      stack: ['STEM Outreach'],
    },
  ],

  education: [
    {
      school: 'The University of Texas at Austin',
      degree: 'Post Graduate Program in Artificial Intelligence and Machine Learning: Business Applications',
      period: 'Nov 2025 - Jul 2026',
      verifyUrl: 'https://la.utexas.edu/texasexeced/digitalVerification.html?key=xnjebhfm',
    },
    {
      school: 'The University of Texas at Dallas',
      degree: 'B.S. Computer Engineering',
      period: '2021 - 2025',
    },
  ],

  certifications: [
    'Certified Entry-Level Python Programmer (PCEP)',
    'Certified Associate in Python Programming (PCAP)',
  ],

  socials: {
    github: 'https://github.com/Hteam121',
    x: 'https://x.com/Hteam121',
    linkedin: 'https://linkedin.com/in/shaik-hatim',
    devpost: 'https://devpost.com/shaikhatim3',
    website: 'https://shaikhatim.com',
    email: 'mailto:shaik@getrerun.app',
  },
};

export default profile;
